import { OffersPromoRepository } from './../../Repository/OffersPromoRepository';
import { PromoBar } from "../../Model/PromoBar/PromoBar";

export interface CreatePromoBarUseCase {
  invoke: (data: PromoBar) => Promise<boolean>;
}

export class CreatePromoBar implements CreatePromoBarUseCase {

  private Repo: OffersPromoRepository;

  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

  async invoke(data: PromoBar){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.Repo.createPromoBar(data);
    return created;
  }
}